import FeatherIcon from '@/components/FeatherIcon.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faElementor } from '@fortawesome/free-brands-svg-icons'

import {
  fas,
  faComments,
  faUserCog,
  faStore,
  faStoreSlash,
  faCheck,
  faDollarSign,
  faFileContract,
  faInfo,
  faPen,
  faHome,
  faPhone,
  faExchangeAlt,
  faInfoCircle,
  faReceipt,
  faUsersCog,
  faFolderPlus,
  faSuitcaseRolling,
  faQuestion,
  faUserPlus,
  faMap,
  faFlag,
  faFlagCheckered,
  faTachometerAlt,
  faUsers,
  faBookmark,
  faGasPump,
  faThumbsUp,
  faExpandArrowsAlt,
  faPlaneDeparture,
  faPlaneArrival,
  faHelicopter,
  faSuitcase,
  faPlus,
  faMinus,
  faPercent,
  faList,
  faIdCardAlt,
  faFileAlt,
  faFileExport,
  faFilePdf,
  faRoute,
  faEdit,
  faArrowsAlt,
  faPrint,
  faDownload,
  faUpload,
  faPaperPlane,
  faHeart,
  faSave,
  faPlusCircle,
  faListAlt,
  faFolder,
  faDonate,
  faCopy,
  faCalendarAlt,
  faPlane,
  faExternalLinkAlt,
  faDollyFlatbed,
  faShoppingBag,
  faBan,
  faGlobeEurope,
  faHistory,
  faCogs,
  faEye,
  faEyeSlash,
  faCreditCard,
  faCheckCircle,
  faClock,
  faTimes,
  faArrowLeft,
  faArrowRight,
  faCaretRight,
  faCaretDown,
  faTrash,
  faCog,
  faChevronUp,
  faChevronDown,
  faUserTie,
  faUser,
  faCalendarDay,
  faCalendarPlus,
  faMapMarkedAlt,
  faStream,
  faFileInvoiceDollar,
  faCommentDots,
  faCommentAlt,
  faCalendarCheck,
  faEraser,
  faLanguage,
  faDatabase,
  faPencilAlt,
  faServer,
  faMoneyCheckAlt,
  faHandshake,
  faWrench,
  faRuler,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  fas,
  faStore,
  faStoreSlash,
  faCheck,
  faDollarSign,
  faFileContract,
  faInfo,
  faPen,
  faHome,
  faPhone,
  faExchangeAlt,
  faHelicopter,
  faInfoCircle,
  faReceipt,
  faUsersCog,
  faSuitcaseRolling,
  faElementor,
  faFolderPlus,
  faCalendarCheck,
  faCommentDots,
  faCommentAlt,
  faComments,
  faFileInvoiceDollar,
  faStream,
  faMapMarkedAlt,
  faQuestion,
  faCalendarPlus,
  faCalendarDay,
  faUserTie,
  faUserCog,
  faUser,
  faUserPlus,
  faMap,
  faFlag,
  faFlagCheckered,
  faTachometerAlt,
  faInfoCircle,
  faGlobeEurope,
  faUsers,
  faBookmark,
  faGasPump,
  faThumbsUp,
  faExpandArrowsAlt,
  faPlaneDeparture,
  faPlaneArrival,
  faHelicopter,
  faUserCog,
  faSuitcase,
  faPlus,
  faMinus,
  faPercent,
  faList,
  faIdCardAlt,
  faFileAlt,
  faFileExport,
  faFilePdf,
  faRoute,
  faEdit,
  faArrowsAlt,
  faPrint,
  faDownload,
  faUpload,
  faPaperPlane,
  faHeart,
  faSave,
  faPlusCircle,
  faListAlt,
  faFolder,
  faDonate,
  faCopy,
  faCalendarAlt,
  faPlane,
  faExternalLinkAlt,
  faDollyFlatbed,
  faShoppingBag,
  faBan,
  faGlobeEurope,
  faHistory,
  faCogs,
  faEye,
  faEyeSlash,
  faCreditCard,
  faCheckCircle,
  faArrowLeft,
  faArrowRight,
  faCaretRight,
  faCaretDown,
  faTrash,
  faCog,
  faClock,
  faTimes,
  faChevronUp,
  faChevronDown,
  faMoneyCheckAlt,
  faEraser,
  faLanguage,
  faDatabase,
  faPencilAlt,
  faServer,
  faHandshake,
  faWrench,
  faRuler,
)

export default {
  install(app) {
    app.component('FontAwesomeIcon', FontAwesomeIcon)
      .component('FeatherIcon', FeatherIcon)
  },
}
